/** Name of the worklist to pre-select on first visit of the physician dashboard page. */
export const DEFAULT_PHYSICIAN_WORKLIST_NAME = 'In Progress';
